import { createApi } from '@core/fetch'

/**
 * 微传单+ API
 */
export default {
  getActivityList: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/list'
  ),
  getAllActivity: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/activity_arr'
  ),
  delActivity: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantActivity/del_activity'
  ),
  getActivityApply: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/activity_apply_all'
  ),
  operateRecord: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantCustomer/operate_record'
  ),
  getPosterInfo: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/poster_info'
  ),
  getActivityDetail: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/activity_detail'
  ),
  createActivity: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantActivity/add',
    {
      ignore: [null, undefined]
    }
  ),
  editActivity: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantActivity/edit',
    {
      ignore: [null, undefined]
    }
  ),
  getFinderList: createApi(
    '/p/wedding/index.php/admin/APIWcdActivity/finder_list'
  ),
  savePosterCover: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantActivity/poster_cover'
  ),
  //获取商家信息
  getShopInfo: createApi.get(
    '/p/wedding/index.php/admin/APIMerchantActivity/activity_merchant_detail'
  ),
  getWeChatInfo: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/activityShareWeChat'
  ),
  saveWeChatInfo: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantActivity/activityShareWeChat'
  ),
  getMealCaseList: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/activityMealList'
  ),
  getHotelHallList: createApi(
    '/p/wedding/index.php/admin/APIMerchantActivity/hotelHallList'
  )
}
